(function($) {
    var $fn = $(".comp_map");
    if($fn.length) {
        $.getScript($cdnjs.googlemap).done(function () {
            $fn.find(".part_map").nl_google_map('init');
            $fn.find(".part_map").nl_google_map('markers_add', function($marker, $markers, $map, $infoWindow){

                function showInfo($marker) {
                    return function () {
                        var $content = "<a href='"+$marker.data.url+"' class='part_ui_info'><div class='elm_row'><h4>"+$marker.title+"</h4><div class='elm_info'>"+$marker.data.text+"</div><span class='icon icon--more'></span></div>";
                        $map.panTo($marker.position);
                        $infoWindow.setContent($content);
                        $infoWindow.open($map,$marker);
                    }
                }

                google.maps.event.addListener($marker, 'click', showInfo($marker));
            });
        });
    }
})(jQuery);